import { render, staticRenderFns } from "./SendVoice.vue?vue&type=template&id=4f7e156a&"
import script from "./SendVoice.vue?vue&type=script&lang=js&"
export * from "./SendVoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports